import { render, staticRenderFns } from "./BusinessUnitCreationModal.vue?vue&type=template&id=f28114be&"
import script from "./BusinessUnitCreationModal.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports